import { definePreset } from '@primeuix/themes';
import Material from '@primeuix/themes/material';

const maridPreset = definePreset(Material, {
  semantic: {
    primary: {
      50: '#e6eef8',
      100: '#b3cce8',
      200: '#809ad8',
      300: '#4d78c8',
      400: '#264fb3',
      500: '#013a8c',
      600: '#013177',
      700: '#012862',
      800: '#011d48',
      900: '#01122e',
      950: '#000b1c',
    },
    colorScheme: {
      light: {
        primary: {
          color: '{primary.700}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.600}',
          activeColor: '{primary.800}',
        },
        highlight: {
          background: '#e8faf4',
          focusBackground: '#d2f5e9',
          color: '#012862',
          focusColor: '#012862',
        },
      },
      dark: {
        primary: {
          color: '#6ee7bc',
          contrastColor: '#012862',
          hoverColor: '#3fcca7',
          activeColor: '#2db891',
        },
        highlight: {
          background: 'rgba(63, 204, 167, 0.16)',
          focusBackground: 'rgba(63, 204, 167, 0.24)',
          color: '#a7f3d5',
          focusColor: '#a7f3d5',
        },
      },
    },
  },
});

export default maridPreset;
